const DiscountSecondCase = {
    name: 'DiscountSecondCase',
    functional: true,
    render: h => (
        <fragment>
            <div class="discount-cases-description">มีได้ทั้งหมด 1 กรณี</div>
            <div class="possible-cases-container">
                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />1 บิดา/มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-baby baby-icon" />
                        <i class="fas fa-baby baby-icon" />2 เด็กเล็ก
                    </div>
                </div>
            </div>
        </fragment>
    ),
}

export default DiscountSecondCase
